import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import * as React from "react";

const InputField = ({
  placeholder,
  helperText,
  maxLength,
  multiline,
  onChange,
  disabled,
  onInput,
  onKeyUp,
  value,
  error,
  type,
  name,
  id,
  adornment,
}) => {
  return (
    <Box>
      <TextField
        fullWidth
        variant="outlined"
        size="small"
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        onInput={onInput}
        value={value}
        adornment={adornment}
        id={id}
        name={name}
        inputProps={{ maxLength: maxLength }}
        disabled={disabled}
        onKeyUp={onKeyUp}
        error={error}
        helperText={helperText}
        multiline={multiline}
      />
    </Box>
  );
};

InputField.propTypes = {
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  adornment: PropTypes.any,
  maxLength: PropTypes.number,
  multiline: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onInput: PropTypes.func,
  onKeyUp: PropTypes.func,
  value: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  error: PropTypes.any,
};
export default InputField;
